import { Link } from "react-router-dom";

import { useFeatureFlags } from "@hooks/http";

export const Labs = () => {
  const { hasFeatureFlag } = useFeatureFlags();

  return (
    <div className="p-12">
      {hasFeatureFlag("enableLandingPageAnalyticsDashboard") && (
        <div className="py-1">
          <Link to="landing-page-analytics">Landing Page Analytics</Link>
        </div>
      )}
      {hasFeatureFlag("enableNotificationsLab") && (
        <div className="py-1">
          <Link to="notifications">Notifications</Link>
        </div>
      )}
    </div>
  );
};
